// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"37":"Homepage","74":"About","121":"Home Layout"}[chunkId] + "." + {"37":"03d2fd54","74":"edb57053","121":"b09871ab"}[chunkId] + ".css";
};